// extracted by mini-css-extract-plugin
module.exports = {"header":"about-module--header--3DrIl","about":"about-module--about--2h0bK","info":"about-module--info--id6da","body":"about-module--body--xmZOA"};